<template>
  <div class="min-h-0 flex-1 overflow-auto bg-gray-50 p-4 dark:bg-slate-800">
    <ActivityTable :activities="taskActivity ?? []" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'TheTaskActivityPage',
  computed: { ...mapGetters({ taskActivity: 'task/getTaskActivity' }) },
  methods: { ...mapActions({ fetch: 'task/fetchTaskActivitiesByTaskID' }) },
  beforeMount() {
    this.fetch({ task_id: this.$route.params.id })
  }
}
</script>
